import { createSelector } from 'reselect'
import { userIdOption } from 'src/components/UserDropdown/UserDropdown'
import { RootState } from 'src/redux/createRootReducer'
import { CreditCardsFullPaginatedDataState } from 'src/redux/creditCardsFullPaginatedData.reducer'
import { selectCreditCardListModelsFromState } from 'src/redux/selectors/data/creditCards.selectors'
import { selectUserListModelsFromState } from 'src/redux/selectors/data/users.selectors'
import { UsersFullPaginatedDataState } from 'src/redux/usersFullPaginatedData.reducer'

export const selectCreditCardsFullPaginatedData = (
  state: RootState,
): CreditCardsFullPaginatedDataState =>
  state.app.accounts.accountsBudgets.creditCardsFullPaginatedData
const selectUniqueCreditCardIds = createSelector(
  [selectCreditCardsFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
const selectUniqueCreditCardListModels = createSelector(
  [selectUniqueCreditCardIds, selectCreditCardListModelsFromState],
  (ids, creditCards) => ids.map((id) => creditCards[id]),
)
export const selectFilteredCreditCards = createSelector(
  [selectUniqueCreditCardListModels],
  (creditCards) => creditCards.filter((cc) => cc.isBudget),
)

export const selectAllUsersFromState = createSelector(
  [selectUserListModelsFromState],
  (users) => Object.keys(users).map((id: string) => userIdOption(users[id])),
)

export const selectUsersFullPaginatedData = (
  state: RootState,
): UsersFullPaginatedDataState =>
  state.app.accounts.accountsBudgets.usersFullPaginatedData
